import { render } from "./CoverUploader.vue?vue&type=template&id=67be09a4&scoped=true"
import script from "./CoverUploader.vue?vue&type=script&lang=js"
export * from "./CoverUploader.vue?vue&type=script&lang=js"

import "./CoverUploader.vue?vue&type=style&index=0&id=67be09a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67be09a4"]])

export default __exports__